import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, Check } from 'lucide-react';
export function ComparisonTable() {
  const rows = [{
    situation: 'Entrar a un lugar',
    without: 'Dudar y esperar',
    with: 'Saber exactamente dónde pararte'
  }, {
    situation: 'La charla',
    without: 'Improvisar frases',
    with: 'Framework de tensión natural'
  }, {
    situation: 'El rechazo',
    without: 'Te arruina la noche',
    with: 'No existe (es parte del proceso)'
  }, {
    situation: 'Resultados',
    without: 'Aleatorios',
    with: 'Predecibles'
  }];
  return <section className="py-24 md:py-32 px-4 bg-bg-card" data-id="element-34">
      <div className="max-w-5xl mx-auto" data-id="element-35">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-text-primary font-display font-bold text-3xl md:text-4xl mb-4 text-center" data-id="element-36">
          ¿Querés el sistema o querés el{' '}
          <span className="text-text-gold" data-id="element-37">atajo</span>?
        </motion.h2>
        <div className="w-12 h-[3px] bg-gold-primary rounded-sm mx-auto mb-6" data-id="element-38" />

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-text-secondary text-lg mb-14 text-center max-w-[640px] mx-auto leading-relaxed" data-id="element-39">
          <strong className="text-text-primary" data-id="element-40">CÓDIGO ACELERADO</strong> es
          para el que no quiere perder 6 meses probando. Son patrones
          documentados de éxito real en hombres argentinos como vos.
        </motion.p>

        <div className="overflow-x-auto rounded-xl border border-border-subtle" data-id="element-41">
          <table className="w-full min-w-[600px]" data-id="element-42">
            <thead data-id="element-43">
              <tr className="bg-bg-input border-b border-border-subtle" data-id="element-44">
                <th className="text-left text-text-secondary text-xs uppercase tracking-[0.08em] p-5 font-bold" data-id="element-45">
                  Situación
                </th>
                <th className="text-left text-text-secondary text-xs uppercase tracking-[0.08em] p-5 font-bold" data-id="element-46">
                  ❌ Hacerlo Solo
                </th>
                <th className="text-left text-text-secondary text-xs uppercase tracking-[0.08em] p-5 font-bold" data-id="element-47">
                  ✅ SISTEMA ACELERADO
                </th>
              </tr>
            </thead>
            <tbody data-id="element-48">
              {rows.map((row, i) => <motion.tr key={i} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className={`${i % 2 === 0 ? 'bg-bg-card' : 'bg-bg-row-alt'} border-b border-border-divider last:border-0`} data-id="element-49">
                  <td className="p-5 text-text-primary text-[15px] font-medium" data-id="element-50">
                    {row.situation}
                  </td>
                  <td className="p-5 text-red-urgency text-[14px] flex items-center gap-2" data-id="element-51">
                    <XCircle className="flex-shrink-0" size={16} data-id="element-52" />
                    {row.without}
                  </td>
                  <td className="p-5 text-text-gold text-[14px] font-bold" data-id="element-53">
                    <div className="flex items-center gap-2" data-id="element-54">
                      <Check className="flex-shrink-0" size={16} data-id="element-55" />
                      {row.with}
                    </div>
                  </td>
                </motion.tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}